import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'boi-form-application-tab',
  templateUrl: './form-application-tab.component.html',
  styleUrls: ['./../../styles/application.page.scss', './form-application-tab.component.scss']
})
export class FormApplicationTabComponent {
  @Input() label: string;

  @Input() routerLink: Array<string | number>;

  @Input() progress: number;

  @Input() hasSubmitValidationError: boolean;

  @Input() cssClass = '';

  @Input() tabOrderNumber: number;

  @Output() public readonly clickOnTab = new EventEmitter<any>();
}
